import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-ib-hero',
  templateUrl: './ib-hero.component.html',
  standalone: false,
})
export class IbHeroComponent {
  @Input() src: string | null = null
  @Input() alt = 'Item'
}
